import { put } from "redux-saga/effects";
import axios from "axios";

import { getFilteredReportListSuccessful, getFilteredReportListFailure} from "../../actions/report"; // action
import {FILTERED_REPORT_LIST} from '../../../api/index.js'
import { setLoading } from "../../actions/loading";

export function* getFilteredReportList({payload}) {
    try {
      yield put(setLoading(true))
      console.log("getFilteredReportList true")
       const reportList = yield axios.put(FILTERED_REPORT_LIST, payload, { withCredentials: true });
      yield put(getFilteredReportListSuccessful(reportList.data));
      yield put(setLoading(false))
      console.log("getFilteredReportList false")

    } catch (error) {
      yield put(getFilteredReportListFailure());
      yield put(setLoading(false))
      console.log("CATCH getFilteredReportList false")

    }
  }
